import { Button } from "@/components/ui/button"
import { Input } from "@/components/ui/input"
import { Label } from "@/components/ui/label"
import { AuthShell } from "@/components/layouts/auth-shell"
import { useForm, usePage, Link } from "@inertiajs/react"
import { FormEvent } from "react"
import { t } from "@/lib/i18n"

/**
 * Asking for a link. The copy speaks to the majority case — someone who forgot
 * a password — because the diner who never had one arrives here from the
 * account screen, where the button already said "Crear contraseña".
 *
 * Outside the diner shell on purpose: whoever is on this screen cannot sign in,
 * so a tab bar for a visit they are locked out of would be furniture.
 */
export default function UserPasswordsNew() {
  const { flash = {} } = usePage<{ flash: { alert?: string; notice?: string } }>().props
  const { data, setData, post, processing } = useForm({ email_address: "" })

  const handleSubmit = (e: FormEvent) => {
    e.preventDefault()
    post("/passwords")
  }

  return (
    <AuthShell title={t("ui.auth.titles.user_password_new")} headline={t("ui.auth.user.headline")} blurb={t("ui.auth.user.blurb")}>
      <div className="mb-8">
        <h1 className="text-2xl font-semibold tracking-tight">
          {t("ui.react.pages.user.passwords.new.title")}
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">
          {t("ui.react.pages.user.passwords.new.description")}
        </p>
      </div>

      <form onSubmit={handleSubmit} data-testid="password-reset-request-form">
        <div className="grid gap-6">
          {flash.alert && (
            <div
              role="alert"
              data-testid="password-request-flash-alert"
              className="rounded-md border border-destructive/40 bg-destructive/10 p-3 text-sm text-destructive"
            >
              {flash.alert}
            </div>
          )}
          <div className="grid gap-2">
            <Label htmlFor="email_address">
              {t("ui.react.pages.user.passwords.new.email")}
            </Label>
            <Input
              id="email_address"
              type="email"
              placeholder={t("ui.react.pages.user.passwords.new.email_placeholder")}
              value={data.email_address}
              onChange={(e) => setData("email_address", e.target.value)}
              required
              autoFocus
              autoComplete="username"
            />
          </div>
          <Button
            type="submit"
            className="w-full"
            disabled={processing}
            data-testid="send-reset-instructions-button"
          >
            {t("ui.react.pages.user.passwords.new.submit")}
          </Button>
          <div className="text-center text-sm">
            <Link href="/session/new" className="underline underline-offset-4">
              {t("ui.react.pages.user.passwords.new.back_to_sign_in")}
            </Link>
          </div>
        </div>
      </form>
    </AuthShell>
  )
}
